/* eslint-disable */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/iframe-has-title */
/* eslint-disable jsx-a11y/heading-has-content */
/* eslint-disable no-script-url */
/* eslint-disable react/style-prop-object */

const ThankYouTemplate = (props) => {
    return (
        <html>
            <head>
                <title>Thank You</title>
                <meta charset="UTF-8" />
                <meta name="viewport" content="width=device-width, initial-scale=1.0" />
                <link rel="shortcut icon" href="images/favicon.png" type="image/x-icon" />
                <link href="https://fonts.googleapis.com/css2?family=Lato:wght@100;300;400;700;900&display=swap" rel="stylesheet" />
                <link
                    href={`${props.serverURL}/public/statics/css/thank-you.css`}
                    rel="stylesheet"
                    type="text/css"
                />
            </head>
            <body>
                <span id='serverURL' style={{ display: 'none' }} >{props.serverURL}</span>
                <span id='propertyID' style={{ display: 'none' }} >{props.id}</span>
                <div class="hero-image">
                    <div class="hero-text">
                        <h1>Thank you for sharing your information</h1>
                        <p>We will contact you soon.</p>
                        <a href="./" class="submit-btn">Back TO Home</a>
                    </div>
                </div>
                <script
                    src={`${props.serverURL}/public/statics/js/jquery.min.js`}
                    type="text/javascript"
                ></script>
                <script
                    src={`${props.serverURL}/public/statics/js/popper.min.js`}
                    type="text/javascript"
                ></script>
                <script
                    src={`${props.serverURL}/public/statics/js/bootstrap.min.js`}
                    type="text/javascript"
                ></script>
                <script
                    src={`${props.serverURL}/public/statics/js/owl.carousel.js`}
                    type="text/javascript"
                ></script>

                <script
                    src={`${props.serverURL}/public/statics/js/jquery.fancybox.min.js`}
                    type="text/javascript"
                ></script>

                <script
                    src={`${props.serverURL}/public/statics/js/thank-you.js`}
                    type="text/javascript"
                ></script>
            </body>
        </html>
    )
}

export default ThankYouTemplate;